import React, { createContext, useContext, useState } from "react";

const STORAGE_KEY = "portfolio-theme";

const ThemeCtx = createContext({ isDark: true, toggleTheme: () => {} });

export const ThemeContextProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved !== null ? saved === "dark" : true; // default: dark
    } catch {
      return true;
    }
  });

  const toggleTheme = () =>
    setIsDark((prev) => {
      const next = !prev;
      try { localStorage.setItem(STORAGE_KEY, next ? "dark" : "light"); } catch {}
      return next;
    });

  return (
    <ThemeCtx.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeCtx.Provider>
  );
};

export const useThemeContext = () => useContext(ThemeCtx);
